export const isInteger = (text: string | number) => {
  const number = Number(text);

  return Number.isInteger(number);
};
